export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const REGISTER = 'registrations';
export const STATUS = 'logged_in';
export const LOGIN = 'sessions';
export const LOGOUT = 'logout';
export const CARS = 'cars';
export const APPOINTMENTS = 'appointments';
export const CITY = ['DHAKA', 'CHITTAGONG', 'RAJSHAHI',
  'KHULNA', 'SYLHET', 'MYMENSINGH', 'BARISHAL',
  'RANGPUR', 'COMILLA', 'NARAYANGANJ', 'GAZIPUR'];
